import { Box, Form } from 'bonfire-kindling';
import { useTranslation } from 'react-i18next';

const commonI18nPath = 'settings.saved_search.edit_or_create';
const SavedSearchSettingsCreateSearchTerms = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Form.TextField
        label={t(`${commonI18nPath}.keywords_include`)}
        helperText={t(`${commonI18nPath}.keywords_explanation`)}
        placeholder={t(`${commonI18nPath}.keywords_include_placeholder`)}
        name="keywords"
        margin="dense"
        fullWidth
        multiline
        rows={3}
      />
      <Form.TextField
        label={t(`${commonI18nPath}.keywords_exclude`)}
        name="excludedKeywords"
        placeholder={t(`${commonI18nPath}.keywords_exclude_placeholder`)}
        margin="dense"
        fullWidth
        multiline
        rows={3}
      />
    </Box>
  );
};

export default SavedSearchSettingsCreateSearchTerms;
